import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { useForm, Controller } from 'react-hook-form';
// import * as yup from 'yup';
// import { yupResolver } from '@hookform/resolvers/yup';
// import ModalResetSetting from './ModalResetSetting';

// import SelectForm from '@components/input/SelectForm';
// import InputForm from '@components/input/InputForm';
// import Switch from '@components/switch/Switch';
import { useDispatch, useSelector } from 'react-redux'; // react 18+ yêu cầu react-redux 7.2.9+
import { RootState } from 'app/store';
import Modal from '@components/common/Modal';
import { updateOpeSettingTable, updateTableSetting } from '@slice/user.slice';

export type TypeSetting = {
  fontSize: string;
  fontStyle: string;
  stripeTable: string;
  modeReSize: string;
  pageSize: number;
};

const initialForm: TypeSetting = {
  fontSize: '13px',
  fontStyle: 'normal',
  stripeTable: '1',
  modeReSize: 'widget',
  pageSize: 100
};

export default function TableSettingModal() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const tableSetting = useSelector((state: RootState) => state.user.tableSetting);
  const openSettingTable = useSelector((state: RootState) => state.user.openSettingTable);
  const [autoSaveWidth, setAutoSaveWidth] = useState<boolean>(false);
  const [autoSaveHiddden, setAutoSaveHiddden] = useState<boolean>(false);
  const [isOpenModalReset, setIsOpenModalReset] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  // const schema = yup.object().shape({});
  // const {
  //   register,
  //   handleSubmit,
  //   watch,
  //   formState: { errors },
  //   reset,
  //   setValue,
  //   control,
  //   getValues
  // } = useForm({
  //   resolver: yupResolver(schema)
  // });

  // const callBackResetSettingAll = (isSync?: boolean) => {
  //   reset(initialForm);
  //   setAutoSaveWidth(true);
  //   setAutoSaveHiddden(true);
  //   setIsOpenModalReset(false);
  //   dispatch(resetSettingTable(isSync));
  // };
  const handleResetSettingAll = () => {
    // console.log('handleResetSettingAll');
    setIsOpenModalReset(true);
  };
  const changeAutoSaveWidthCol = () => {
    setAutoSaveWidth(!autoSaveWidth);
  };
  const changeAutoSaveHiddenCol = () => {
    setAutoSaveHiddden(!autoSaveHiddden);
  };
  const handleCancel = () => {
    dispatch(updateOpeSettingTable(false));
  };

  // const handleOk = () => {
  //   try {
  //     if (props.rowSelect) {
  //       setConfirmLoading(true);
  //       // xoá ở local
  //       props.callBackDelete();
  //       //      gọi api
  //       //     await BusManagementServiceApi.DeleteFeeForPenalty(props.rowSelect.CompanyId!, props.rowSelect.Id).then(res => {
  //       //         if (res.data.Status === 1) {
  //       //             Toast(t("ManagerBus.FeedForViolationPenalties.SuccessMessage.Delete"), ToastType.SUCCESS)
  //       //             props.callBackClose()
  //       //             props.callBackRefresh()
  //       //         }
  //       //     })

  //       // cần hiện popup cập nhật xong
  //       // có thể đặt trong kq của api trả về
  //       setTimeout(() => {
  //         setConfirmLoading(false);
  //         props.callBackClose();
  //       }, 1000);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const handleCancel = () => {
  //   props.callBackClose();
  // };

  const handleAction = (data?: any) => {
    try {
      if (data) {
        // console.log('data', data);
        // props.callBackSetProps(data);
        // setIsOpenSettingModal(false);
        const tableSettingPre = {
          fontSize: data.fontSize,
          sizePage: data.pageSize,
          fontStyle: data.fontStyle,
          stripe: data.stripeTable == '1' ? true : false,
          autoSaveColumnHidden: autoSaveHiddden,
          autoSaveColumnWidth: autoSaveWidth,
          resizingMode: data.modeReSize
        };
        // console.log('update setting', tableSettingPre);
        dispatch(updateTableSetting(tableSettingPre));
        dispatch(updateOpeSettingTable(false));
      }
    } catch (error) {
      // setIsOpenSettingModal(false);
      // console.log("sss", error)
    }
  };

  const pageSize = [
    {
      value: 50,
      label: '50'
    },
    {
      value: 100,
      label: '100',
      title: '(Mặc định)'
    },
    {
      value: 200,
      label: '200'
    },
    {
      value: 300,
      label: '300'
    }
  ];

  const fontSize = [
    {
      value: '11px',
      label: '1',
      title: '11px'
    },
    {
      value: '12px',
      label: '2',
      title: '12px'
    },
    {
      value: '13px',
      label: '3',
      title: '13px (Mặc định)'
    },
    {
      value: '14px',
      label: '4',
      title: '14px'
    }
  ];

  const fontStyle = [
    {
      value: 'normal',
      label: 'Thường',
      title: '(Mặc định)'
    },
    {
      value: 'initial',
      label: 'Tiêu chuẩn'
    },
    {
      value: 'italic',
      label: 'Chữ nghiêng'
    }
  ];
  const modeReSize = [
    {
      value: 'widget',
      label: 'Khối cột',
      title: '(Mặc định)'
    },
    {
      value: 'nextColumn',
      label: 'Cột liền kề'
    }
  ];

  useEffect(() => {
    // console.log('tableSetting', tableSetting);
    // props.autoSaveColumnHidden && setEnabledAutoSave(props.autoSaveColumnHidden);
    if (tableSetting && openSettingTable) {
      // setValue('fontSize', tableSetting.fontSize ? tableSetting.fontSize : '13px', { shouldValidate: true });
      // setValue('fontStyle', tableSetting.fontStyle, { shouldValidate: true });
      // setValue('stripeTable', tableSetting.stripe ? '1' : '0', { shouldValidate: true });
      // setValue('modeReSize', tableSetting.resizingMode ? tableSetting.resizingMode : 'widget', {
      //   shouldValidate: true
      // });
      // setValue('pageSize', tableSetting.sizePage, { shouldValidate: true });
      setAutoSaveHiddden(tableSetting.autoSaveColumnHidden);
      setAutoSaveWidth(tableSetting.autoSaveColumnWidth);
    }
  }, [openSettingTable]);

  return (
    <Modal
      modalTitle={t('Table.Setting.ModalSetting.Title')}
      visible={openSettingTable}
      onOk={handleAction}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      modalType="reset"
      // handleCancel={() => handleCancel()}
      // callBackClose={() => handleCancel()}
      // handleAction={handleSubmit(handleAction)}
      // isOpen={openSettingTable!}
      // title={t('Table.Setting.ModalSetting.Title')}
      // actionTitle={t('Modal.Apply')}
      // childButtonLeft={
      //   <div
      //     onClick={() => handleResetSettingAll()}
      //     className="shadow cursor-pointer rounded-md bg-yellow-300 p-2 hover:bg-yellow-400 font-medium"
      //   >
      //     {t('Table.Setting.ModalSetting.Reset')}
      //   </div>
      // }
    >
      This Coming Soon
      {/* thêm: 
      Reset option mặc định all
      tự động lưu kích thước
      Tự động lưu cột ẩn
      Số lượng hàng mỗi trang
      Chế độ resize */}
      {/* 
      <div className="flex flex-row space-x-2">
        <SelectForm
          control={control}
          fieldName={'fontSize'}
          isRequired={false}
          register={register}
          title={t('Table.Setting.ModalSetting.FontSize')}
          options={fontSize}
          maxHeightMenu={150}
        />
        <SelectForm
          control={control}
          fieldName={'pageSize'}
          isRequired={false}
          register={register}
          title={t('Table.Setting.ModalSetting.InitPageSize')}
          options={pageSize}
          maxHeightMenu={150}
        />
      </div>
      <div className="flex flex-row space-x-2">
        <SelectForm
          control={control}
          fieldName={'fontStyle'}
          isRequired={false}
          register={register}
          title={t('Table.Setting.ModalSetting.FontStyle')}
          options={fontStyle}
          maxHeightMenu={120}
        />
        <SelectForm
          control={control}
          fieldName={'modeReSize'}
          isRequired={false}
          register={register}
          title={t('Table.Setting.ModalSetting.ModeResize')}
          options={modeReSize}
          maxHeightMenu={120}
        />
      </div>

      <label
        style={{ fontFamily: 'roboto', fontSize: '13px' }}
        className="block tracking-wide text-xs mb-2 mt-2"
        htmlFor="grid-first-name"
      >
        {t('Table.Setting.ModalSetting.TypeStripe')}
      </label>
      <div className="flex justify-between w-3/4">
        <InputForm
          type="radio"
          radioValue={0}
          error={errors}
          register={register}
          fieldName="stripeTable"
          title={t('Table.Setting.ModalSetting.NoStripeTable')}
        />
        <InputForm
          type="radio"
          radioValue={1}
          error={errors}
          register={register}
          fieldName="stripeTable"
          title={t('Table.Setting.ModalSetting.StripeTable')}
        />
      </div>

      <label
        style={{ fontFamily: 'roboto', fontSize: '13px' }}
        className="block tracking-wide text-xs mb-2 mt-4"
        htmlFor="grid-first-name"
      >
        {t('Table.Setting.ModalSetting.SmartAct')}
      </label>
      <div className="flex flex-row space-x-4">
        <div>
          <Switch value={autoSaveWidth} onChange={changeAutoSaveWidthCol} />{' '}
          <label style={{ fontFamily: 'roboto', fontSize: '13px' }}>
            {t('Table.Setting.ModalSetting.AutoSaveWidth')}
          </label>
        </div>
        <div>
          <Switch value={autoSaveHiddden} onChange={changeAutoSaveHiddenCol} />{' '}
          <label style={{ fontFamily: 'roboto', fontSize: '13px' }}>
            {t('Table.Setting.ModalSetting.AutoSaveHiddden')}
          </label>
        </div>
      </div> */}
      {/* <ModalResetSetting
        callBackAction={callBackResetSettingAll}
        isOpen={isOpenModalReset}
        callBackClose={() => setIsOpenModalReset(false)}
      /> */}
    </Modal>
  );
}
